module.exports = __webpack_public_path__ + "img/Jumbotron.2e42d4fb.jpg";